module.exports = __webpack_public_path__ + "static/media/course_03.39a4e929.jpg";